export default {
  getSuppliersShortStatistic(state) {
    return state.suppliersShortStatistic
  },
  getTenderSuppliersInfo(state) {
    return state.tenderSuppliersInfo
  },
  getCrmVerificationFillingInfo(state) {
    return state.crmVerificationFillingInfo
  },
}